import { appUrl } from 'utils/wrappers';

import ReportsBase from 'app/collections/reports_base';
import ShipmentReport from 'app/models/shipment_report';

export default ReportsBase.extend({
  model: ShipmentReport,
  url: appUrl('reports/shipment'),
});



// WEBPACK FOOTER //
// ./app/collections/shipment_reports.js